<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="500">
      <v-form ref="CompanyProfileFormRef" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>{{ action }} Company Contact Person</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="contact_person"
                    label="Name"
                    :rules="[formRules.required]"
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="contact_person_position"
                    label="Position"
                    :rules="[formRules.required]"
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="phone_no"
                    label="Phone Number"
                    :rules="[formRules.required]"
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="save()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
    title: String,
    typeToSave: String,
  },
  data() {
    return {
      dialog: false,
      showDatePicker: false,
      btnLoading: false,
      name: null,
      address: null,
      description: null,
      website: null,
      email: null,
      contact_person: null,
      contact_person_position: null,
      about_company: null,
      phone_no: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.initialize();

        if (!data.id) {
          this.initialize();
        }
      },
      deep: true,
    },
  },
  methods: {
    initialize() {
      this.axiosCall("/organization/getInfo", "GET").then((res) => {
        if (res.data) {
          console.log("org", res.data);
          this.contact_person = res.data.contact_person;
          this.phone_no = res.data.phone_no;
          this.contact_person_position = res.data.contact_person_position;
        }
      });
    },

    async save() {
      let formValid = await this.$refs.CompanyProfileFormRef.validate();

      if (formValid.valid) {
        this.btnLoading = true;
        let data = {
          contact_person: this.contact_person,
          contact_person_position: this.contact_person_position,
          phone_no: this.phone_no,
        };

        this.axiosCall("/organization/updateProfile", "PATCH", data).then(
          (res) => {
            console.log(res);
            if (res.data.status == 200) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
              this.btnLoading = false;
              this.closeD();
            } else {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            }
          },
        );
      }
    },

    closeD() {
      eventBus.emit("closeUpdateCompanyContactPersonDialog", true);
      this.btnLoading = false;
      this.dialog = false;
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}
</style>
